import { ConfigService } from '@/configuration/services/configService';

export const TITLE_PREFIX = ConfigService.get().application.titlePrefix;
export const BASE_PATH: string = import.meta.env.VITE_BASE_PATH as string;
